import Actions from '../actions'

const defaultState = {
  activePageName: 'OVERVIEW', // should be UIActions.enums.pageNames.OVERVIEW but I'm not quite sure where to put the enums
  isNewGameTabOpen: false,
  isInviteTabOpen: false,
  isActiveTabOpen: false,
  isPastTabOpen: false,
}

function setActivePage (state, activePageName) {
  return { ...state, activePageName}
}

function setNewGameTab (state, isNewGameTabOpen) {
  return { ...state, isNewGameTabOpen}
}

function setInviteTab (state, isInviteTabOpen) {
  return { ...state, isInviteTabOpen}
}

function setActiveTab (state, isActiveTabOpen) {
  return { ...state, isActiveTabOpen}
}

function setPastTab (state, isPastTabOpen) {
  return { ...state, isPastTabOpen}
}

function uiReducer (state = defaultState, action) {
  switch (action.type) {
    case Actions.UI_SET_ACTIVE_PAGE:
      return setActivePage(state, action.payload)
    case Actions.UI_SET_NEW_GAME_TAB:
      return setNewGameTab(state, action.payload)
    case Actions.UI_SET_INVITE_TAB:
      return setInviteTab(state, action.payload)
    case Actions.UI_SET_ACTIVE_TAB:
      return setActiveTab(state, action.payload)
    case Actions.UI_SET_PAST_TAB:
      return setPastTab(state, action.payload)

    default:
      return state
  }
}

export default uiReducer
